export const sidebarWidth = 400;//px
export const sidebarMinWidth = 150;//px
export const sidebarOpenOffset = (sidebarWidth - sidebarMinWidth) / 2;
export const boardMargin = 20;//px

export const cardAspectRatio = 102.0/143.0;
export const cardGap = .5;//vh

export const circleHeight = 95;//vh

export const snackbarHeight = 38;//px

export const mobileWidth = 576;//px

export const tabletWidth = 992;//px

export const desktopWidth = 1280;//px

export const adHeight = 50;//px
// Phones: fixed heights for the message bar and the Call RAFIKI!/Slam bar at the bottom,
// so the table never jumps when a message wraps onto a second line.
export const phoneSnackHeight = 56;//px
export const phoneBarHeight = 58;//px
// The 320x50 sidebar banner plus a labelled gap above it, so a click meant for the leaderboard
// above can't land on the ad.
export const desktopAdHeight = 76;//px

export const leaderboardZIndex = 100;
export const desktopAdZIndex = leaderboardZIndex + 100;
// Phones: the room menu and leaderboard sit in a slim row above the table.
export const phoneMenuHeight = 34;//px
// Phones: the height of every box in that row (room, Scores, Rules, speaker), and the gap between
// them, which is also the gap left between the row and the table (phoneMenuHeight - height - gap
// above the row).
export const phoneHudHeight = 28;//px
export const phoneHudGap = 4;//px
// Phones: the bottom panel (tip, Call RAFIKI!/Slam buttons and message) reaches this far above
// the buttons, so its rounded top edge clears them.
export const phoneDockLip = 6;//px
// Phones: the clear gap between the table's gold rim and the top of the bottom panel. It used to
// be 4px, which with the table's shadow read as the rim sitting on the buttons (tester, 1 Nov 2026).
export const phoneTableGap = 8;//px
// Phones: room left under the table for the bottom panel, plus that gap.
export const phoneDockGap = phoneDockLip + phoneTableGap;//px

// A tap target of at least 44 × 44 px on phones (Apple's and Google's minimum) without changing
// how the control looks: an invisible area around it takes the tap (critic issue #102).
export const hitArea44 = `
  @media (max-width: ${mobileWidth}px) {
    position: relative;
    &::before {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      width: max(100%, 44px);
      height: max(100%, 44px);
      transform: translate(-50%, -50%);
    }
  }
`;
